<template>
  <div v-if="isSupportedActionable">
      <span>
            <div v-if="commentCount > 0" class="notification-header-clickable">
              <a @click.prevent="viewComment"><img class="notification-type-icon" src="/images/notifications/comment-column-icon.svg" /></a>
            </div>
            <div v-else style="margin: auto">-</div>
      </span>
  </div>
</template>

<script>

import {
  TYPE_COMMENT,
  TYPE_FILE,
  TYPE_ORDER,
} from './../../common/constants';

export default {
  name: "notification-actionable",
  props: ['action', 'orderId', 'commentCount'],
  data: function() {
    return {
      TYPE_COMMENT,
      TYPE_FILE,
      TYPE_ORDER,
      supportedActionables:[
          TYPE_COMMENT,
          TYPE_FILE,
          TYPE_ORDER,
        ]
    }
  },
  methods: {
    viewComment () {
      const orderId = this.orderId;
      $.get('/ajax/reports',
          {report: 'order-comments', id: orderId}, function (data) {
            let content = '<div class="popup-comment order-comments">' + data + '</div>';

            let popup = new PopupConfirmDialog(content,
                {
                  messageTitle: 'Order ' + orderId + ' Comments',
                  confirmCallback: function () {
                    $(`<a href="/orders/view/${orderId}/?t=comment" target="blank"></a>`)[0].click();
                  },
                  confirmButtonText: 'Open Order',
                  cancelButtonText: 'Close',
                  showConfirmButton: true,
                  showCancelButton: true,
                  showInput: false
                }
            );
            popup.show();
          }, "html");
    },
  },
  computed: {
    isSupportedActionable(){
      return this.supportedActionables.includes(this.action.type)
    }
  }
};
</script>
